import React from 'react';


export default function Contact() {
  return (
      <div className="sec-wrapper">
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ OFFICIAL BUSINESS HEADQUARTERS ✦
            </span>
          </div>

          <h1 className="hero-title">
            Contact & Corporate <span className="hero-title-gradient">Offices in Nepal</span>
          </h1>

          <p className="hero-subtitle">
            Main Business Office: <strong>Yogikuti Chowk, Butwal-10, Nepal</strong>. Resident Director: <strong>Laxmikant Timilsina</strong> (Tansen-09, Palpa | 9857074103).
          </p>

          <div className="hero-cta-group">
            <a href="tel:9857074103" className="btn btn-secondary">
              📞 Call Matrimony (9857074103)
            </a>
            <a href="tel:9867155395" className="btn btn-tertiary">
              📞 Call Catering & Decor (9867155395)
            </a>
          </div>
        </div>
      </section>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem'
        }}>
          {/* Office 1: Matrimonial Office */}
          <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>💍</div>
            <span className="badge-light" style={{ background: '#FAF6ED', color: '#8C6A23', marginBottom: '0.6rem' }}>
              Matrimonial Consultation Agency
            </span>
            <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
              Vivah Nepal Matrimony
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.8rem' }}>
              Managing Director: Laxmikant Timilsina
            </div>
            <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              📍 Location: Yogikuti, Butwal, Nepal.<br />
              📲 QR Payment & Direct Phone: <strong>9857074103</strong><br />
              🎁 Registration Fee: 100% FREE
            </p>
            <a href="tel:9857074103" className="btn btn-primary btn-full">
              📞 Call Laxmikant: 9857074103 →
            </a>
          </div>

          {/* Office 2: Catering & Decor */}
          <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>🏢</div>
            <span className="badge-light" style={{ background: '#FAF6ED', color: '#8C6A23', marginBottom: '0.6rem' }}>
              Catering & Tent House Services
            </span>
            <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
              Sabitri Catering & Tent House
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.8rem' }}>
              Managing Director: Krishna Khanal
            </div>
            <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              📍 Location: Yogikuti, Butwal, Nepal.<br />
              📞 Direct Phone: <strong>9867155395</strong><br />
              🍱 Banquets, Palpali Bhoj, Marquee Tents & Mandap Decor
            </p>
            <a href="tel:9867155395" className="btn btn-secondary btn-full">
              📞 Call Krishna: 9867155395 →
            </a>
          </div>

          {/* Office 3: Technical Support */}
          <div className="card" style={{ border: '1.5px solid #E8DFD1' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>💻</div>
            <span className="badge-light" style={{ background: '#FAF6ED', color: '#8C6A23', marginBottom: '0.6rem' }}>
              Lead Technical Support
            </span>
            <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
              Prakash Sharma Timilsina
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.8rem' }}>
              Chief Technical Advisory & System Architect
            </div>
            <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              Leads Django Python backend, React frontend infrastructure, GCP cloud server hosting, and digital platform security.
            </p>
            <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-full">
              Visit Digital Portfolio: pourkas.org →
            </a>
          </div>
        </div>
      </div>
    
  );
}